import {
  IFallbackCasesQuery,
  IFallbackCasesResponse,
} from "types/BenefitFallbackCases/BenefitFallbackCases";

import { api } from ".";

/**
 * CLE-3047 — Eligibility › Fallbacks, the checks list: every live check whose co-insurance or copay came from another service
 * line or from earlier patients. READ ONLY, SuperAdmin only on the API. Paged and filtered on the server. The rows are
 * written by live eligibility checks, never by this page, so the tab refetches each time it is opened
 * (`refetchOnMountOrArgChange` at the call site) rather than relying on tags.
 */
export const BENEFIT_FALLBACK_CASES_PATH = "eligibility/benefit-fallback-cases";

/** `usedOnly` always goes out, so the server never has to guess; empty filters do not. */
export const fallbackCasesParams = (query: IFallbackCasesQuery) =>
  Object.fromEntries(
    Object.entries({ ...query, usedOnly: String(query.usedOnly) }).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );

export const benefitFallbackCaseQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getBenefitFallbackCases: builder.query<
      IFallbackCasesResponse,
      IFallbackCasesQuery
    >({
      query: (query) => ({
        url: BENEFIT_FALLBACK_CASES_PATH,
        params: fallbackCasesParams(query),
      }),
      transformResponse: (response: { data: IFallbackCasesResponse }) =>
        response.data,
    }),
  }),
});

export const { useGetBenefitFallbackCasesQuery } = benefitFallbackCaseQueries;
